import { PageStep } from '../../../Common/PopUp/PageStepsProps';

export const SendEmailPageSteps: PageStep[] = [
  {
    selector: '.email-editor',
    content:
      'For better experience be in light mode while editing email template',
  },
];
